// extracted by mini-css-extract-plugin
export default {"dateReviewedContainer":"CareElementDateReviewed_dateReviewedContainer__jjtcB","datePickerWrapper":"CareElementDateReviewed_datePickerWrapper__OqZh8"};